<template>
  <div class="row justify-center text-center">
    {{ t(`message`) }}
  </div>
  <div class="row justify-center">
    <div class="sm:col-auto flex flex-col lg:block pt-2">
      <button
        type="button"
        data-dismiss="modal"
        class="btn btn-danger m-1 py-3 px-8 rounded-pill"
        @click="modalStore.closeModal"
      >
        {{ t(`finish_mix`) }}
      </button>
      <button
        type="button"
        class="btn btn-success m-1 py-3 px-8 rounded-pill"
        @click="switchMixKind"
      >
        {{ t(`switch_category`) }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

import { useModalStore } from '@/stores/ModalStore'

const router = useRouter()
const { t } = useI18n()

const modalStore = useModalStore()
const { getParams } = storeToRefs(modalStore)

const switchMixKind = () => {
  router.push({ name: 'mixesPath', query: { force: true }, params: { permalink: getParams.value.permalink } })
}
</script>

<i18n>
  {
    "cs": {
    "finish_mix": "Domixovat",
    "message": "Chystáte se přejít do jiné mixovací kategorie. Chcete domixovat nebo přejít?",
    "switch_category": "Přejít na kategorii"
},
    "sk": {
    "finish_mix": "Domixovať",
    "message": "Chystáte sa prejsť do inej mixovacej kategórie. Chcete domixovat alebo prejsť?",
    "switch_category": "Prejsť na kategóriu"
},
    "pl": {
    "finish_mix": "Dokończ mieszankę",
    "message": "Zamierzasz przejść do nowej kategorii. Chcesz dokończyć mieszankę albo przejść?",
    "switch_category": "Przejdź do kategorii"
},
    "hu": {
    "finish_mix": "Befejezés",
    "message": "Másik mixelési kategóriára szeretnél átugrani. Be szeretnéd befejezni a mixelést vagy átugrasz?",
    "switch_category": "Ugrás a kategóriába"
},
    "de": {
    "finish_mix": "Fertig mischen",
    "message": "Du bist dabei, in eine andere Mix-Kategorie zu wechseln. Möchtest du deinen Mix fertig mischen oder wechseln?",
    "switch_category": "Zur Kategorie gehen"
},
    "at": {
    "finish_mix": "Fertig mischen",
    "message": "Du bist dabei, in eine andere Mix-Kategorie zu wechseln. Möchtest du deinen Mix fertig mischen oder wechseln?",
    "switch_category": "Zur Kategorie gehen"
},
    "ro": {
    "finish_mix": "Termină amestecul",
    "message": "Ești pe cale să treci într-o altă categorie de mix. Vrei să termini amestecul sau să încerci altă categorie?",
    "switch_category": "Treci în altă categorie"
},
    "fr": {
    "finish_mix": "Terminer de mixer",
    "message": "Vous êtes sur le point de passer à une autre catégorie de mixage. Souhaitez-vous terminer le mix actuel ou passer à la suivante ?",
    "switch_category": "Passer à la catégorie"
}
  }
</i18n>
